// Pane option builders. Each reads from viewer + the uploaded
// dataset registry to produce a {label: value} map for dropdowns.

import { uploadedDatasets } from '@app/uploadedDatasets';
import type { ViewerContext } from '@app/context';

export function colormapOptions(viewer: ViewerContext): Record<string, string> {
    const opts: Record<string, string> = {};
    Object.keys(viewer.colormap.defs).forEach((name) => { opts[name] = name; });
    if (Object.keys(opts).length === 0) opts['Rainbow'] = 'Rainbow';
    return opts;
}

export function datasetOptions(viewer: ViewerContext): Record<string, string> {
    const opts: Record<string, string> = {};
    const base = Object.keys(viewer.sceneMeta.datasetMap || {});
    const uploaded = Array.from(uploadedDatasets.keys());
    const keys = Array.from(new Set([...base, ...uploaded]));
    if (keys.length) {
        keys.forEach((name) => {
            const isUploaded = uploaded.includes(name);
            opts[isUploaded ? `Uploaded: ${name}` : name] = name;
        });
    } else {
        opts['Dipole Field'] = 'dipole_field';
    }
    return opts;
}

